function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
import SVG from "../../layouts/SVG.js";
export var Wine = function Wine(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.51V21.7401M8.25 21.75H15.75M5.40002 9.40095C6.39363 8.87287 8.69391 8.09694 12 9.74999C15.5209 11.5104 17.9056 10.5161 18.78 10M7.5 2.25H16.5L18.943 10.5261C19.096 11.043 19.0581 11.5977 18.8363 12.0891C18.2416 13.4039 17.2804 14.5192 16.0679 15.3016C14.8554 16.0839 13.443 16.5 12 16.5C10.557 16.5 9.14464 16.0839 7.93213 15.3016C6.71962 14.5193 5.75841 13.4039 5.16371 12.0892C4.94188 11.5978 4.90403 11.043 5.05706 10.5261L7.5 2.25Z",
    stroke: color || '#333333',
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};